export default {
  footerQuickLinks: "Liens rapides",
  footerAboutRLS: "À propos de RLS",
  footerOurJourney: "Notre parcours",
  footerLeadershipTeam: "Équipe dirigeante",
  footerContactUs: "Contactez-nous",
  footerConnectWithUs: "Connectez-vous avec nous",
  footerAllRightsReserved: "2025 Refex Life Sciences. Tous droits réservés.",
  footerPrivacyPolicy: "Politique de confidentialité",
  footerTermsOfService: "Conditions d'utilisation",
};

